<div class="app-text-chat-widget column-flex-container bc-work-item-theme {{textChatThemeClass}}">
  <work-widget-header class="bc-panel column-flex-fix" *ngIf="isMultiLane && textChat" [workItem]="workItem" [title]="visitor?.fields.name?.value" [visitor]="visitor"></work-widget-header>

  <div class="text-chat-widget-content column-flex-grow multilane-wrapper panel-shadow-wrapper" *ngIf="textChat">

    <div class="multilane-item multilane-item-1 bc-work-lane"
         [ngClass]="{ 'col-md-12 col-lg-12': !isExpandedMode(), 'col-md-4 col-lg-4': isExpandedMode() }">
      <div class="bc-panel-maxh">
        <work-widget-header *ngIf="!isMultiLane" [workItem]="workItem" [title]="visitor?.fields.name?.value"></work-widget-header>

        <app-text-chat-box [textChat]="textChat" [cannedMessageRequest]="cannedMessageRequest" [isCannedMessagePanelOpen]="isCannedMessagePanelOpen" [workItem]="workItem" tabindex="-1"></app-text-chat-box>
      </div>
    </div>

    <div class="multilane-item multilane-item-1 bc-work-lane cm-lane-wrapper"
         [attr.data-automation-id]="'SMART_ADVISOR'"
         *ngIf="isFeatureConfigLoaded() && isTextChatActive() && doesCustomerUseNanorep() && isSmartAdvisorLaneVisible"
         [ngClass]="{ 'col-xs-12 col-sm-12 col-md-4 col-lg-4 bc-middle-lane': isExpandedMode() }">
      <nanorep-panel
        [workItemId]="workItem.id"
        [workItemType]="workItem.type"
        [isOpened]="isExpandedMode() || (isCannedMessagePanelOpen && isSmartAdvisor)"
        [isExpanded]="isExpandedMode()"
        [nanorepConfigId]="workItem.NanorepConfigID"
        [visitor]="visitor"
        (panelClose)="onNanorepPanelClose()">
      </nanorep-panel>
    </div>
    <div class="multilane-item multilane-item-1 bc-work-lane cm-lane-wrapper"
         [attr.data-automation-id]="'CANNED_MESSAGES'"
         *ngIf="isFeatureConfigLoaded() && isTextChatActive() && isCannedMessagesLaneVisible"
         [ngClass]="{ 'col-xs-12 col-sm-12 col-md-4 col-lg-4 bc-middle-lane': isExpandedMode() }">
      <app-canned-message-panel
        *ngIf="!isSmartAdvisor || isExpandedMode()"
        [cannedMessageRequest]="cannedMessageRequest"
        [workItemId]="workItem.id"
        [workItemType]="workItem.type"
        [isOpened]="isExpandedMode() || isCannedMessagePanelOpen"
        [isExpanded]="isExpandedMode()"
        [isCannedMessagesTabActive]="isCannedMessagesTabActive"
        [isCustomTabActive]="isCustomTabActive"
      >
      </app-canned-message-panel>
    </div>

    <div class="multilane-item multilane-item-1 bc-work-lane"
         [attr.data-automation-id]="'VISITOR_INFO_PANEL'"
         *ngIf="isExpandedMode() && isVisitorInfoLaneVisible">
      <app-detailed-data [workItemType]="workItem.type" [workItemId]="workItem.id" class="bc-panel" [isNotAvailableDataHidden]="true"></app-detailed-data>
    </div>

    <div class="multilane-item multilane-item-1 bc-work-lane"
         *ngIf="isExpandedMode() && isVisitorHistoryLaneVisible">
      <div class="history-wrapper">
        <app-assignment-history class="bc-panel"
                                *ngIf="hasAssignmentHistoryPermission && textChat"
                                [textChatId]="textChat.TextChatID"
                                [isItemClosed]="!!textChat.Closed"
                                [attr.data-automation-id]="'ASSIGNMENT_HISTORY_PANEL'">
        </app-assignment-history>
        <app-visitor-history class="bc-panel"
                             *ngIf="textChat"
                             [textChatId]="textChat.TextChatID"
                             [relation]="getRelation()"
                             [attr.data-automation-id]="'VISITOR_HISTORY_PANEL'">
        </app-visitor-history>
      </div>
    </div>

    <ng-container *ngFor="let integration of integrationWorkItemLanes">
      <div class="multilane-item multilane-item-{{ integration.width }} integration-panel bc-work-lane bc-panel"
           [attr.data-integration-id]="integration.id"
           [attr.data-automation-id]="integration.name"
           *ngIf="integration.visible && isExpandedMode()">
        <div *ngIf="!isSalesforceIntegration(integration)" class="bc-panel-header integration-panel-header">
          <span class="bc-panel-header-text">{{ integration.name }}</span>

          <button class="refresh pull-right" *ngIf="isEmbeddedIntegration(integration)" (click)="reloadIFrameUrlFromServer(integration)" [title]="'bcChatWidget.refresh' | translate">
            <svg-icon icon="refresh"></svg-icon>
          </button>
        </div>

        <div class="frame-container" *ngIf="isEmbeddedIntegration(integration)">
          <app-refreshable-frame [src]="integration.src" (onSrcRefresh)="reloadIFrameUrlFromServer(integration)"></app-refreshable-frame>
        </div>
        <div class="salesforce-lane-container" *ngIf="isSalesforceIntegration(integration)">
          <app-salesforce-lane [chatId]="chat.ChatID"></app-salesforce-lane>
        </div>
      </div>
    </ng-container>

  </div>
</div>
